import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './Countdown';
export function UrgencyBlock() {
  return <section aria-labelledby="urgencia-titulo" className="w-full border-y-4 border-gold bg-navy-deep py-10 text-white sm:py-12" data-id="element-261" data-mp="3iqn0b032mjzc">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-262" data-mp="39y1k9rqtqre7">
        <h2 id="urgencia-titulo" className="font-display text-xl font-extrabold uppercase tracking-widest text-gold sm:text-2xl" data-id="element-263" data-mp="39xjg88xx78vq">
          ⏰ Precio de lanzamiento — cierra en:
        </h2>

        <div className="mt-5" data-id="element-264" data-mp="301yiwo3sqwsb">
          <Countdown data-id="element-265" data-mp="2uzzfxfbyy1vw" />
        </div>

        <p className="mt-6 inline-flex items-center gap-2 rounded-full bg-coral/15 px-4 py-2 text-sm font-bold text-white ring-1 ring-coral/40" data-id="element-266" data-mp="2v111weuiw8se">
          <AlertTriangleIcon className="h-4 w-4 text-coral" aria-hidden="true" data-id="element-267" data-mp="t8w4inu98jaa" />
          Después sube $8.000 ARS. No vuelve.
        </p>

        <div className="mx-auto mt-7 max-w-md text-left" data-id="element-268" data-mp="p8vr96iw6e4t">
          <p className="flex items-center gap-2 text-sm font-bold text-white" data-id="element-269" data-mp="14xx2t17xdemd">
            <span className="h-2.5 w-2.5 animate-pulse rounded-full bg-coral" aria-hidden="true" data-id="element-270" data-mp="15002kcyvqm4a" />
            Cupos al precio de lanzamiento — quedan pocos
          </p>
          <div className="mt-2 h-3 w-full overflow-hidden rounded-full bg-white/15" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos al precio de lanzamiento tomados" data-id="element-271" data-mp="vyjs6582ek02">
            <div className="h-full w-[68%] rounded-full bg-coral" data-id="element-272" data-mp="1smq2n8ro46m9" />
          </div>
          <p className="mt-2 text-xs font-semibold text-white/70" data-id="element-273" data-mp="1eus1pl841h16">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </section>;
}